import { render, staticRenderFns } from "./OffsetMenu.vue?vue&type=template&id=6616454f&scoped=true"
import script from "./OffsetMenu.vue?vue&type=script&lang=js"
export * from "./OffsetMenu.vue?vue&type=script&lang=js"
import style0 from "./OffsetMenu.vue?vue&type=style&index=0&id=6616454f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6616454f",
  null
  
)

export default component.exports